
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      // show/hide initials input
      const cb = this.form.querySelector('#gw-monogram-checkbox');
      const wrap = this.form.querySelector('#gw-monogram-input-wrap');
      if (cb && wrap) cb.addEventListener('change', () => wrap.style.display = cb.checked ? 'block' : 'none');
    }

    getSectionIds() {
      const list = this.cartNotification?.getSectionsToRender?.() || [];
      return list.map(s => s.id);
    }

    async safeRenderSections(sectionIds) {
      try {
        const res = await fetch(`/?sections=${encodeURIComponent(sectionIds.join(','))}`);
        const sections = await res.json();
        this.cartNotification?.renderContents?.({ sections });
      } catch (e) {
        console.error('Fallback sections fetch failed', e);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton?.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification?.setActiveElement?.(document.activeElement);

      submitButton?.setAttribute('aria-disabled', true);
      submitButton?.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type']; // let FormData set boundary

      const sectionIds = this.getSectionIds();

      // --- detect monogram intent ---
      const monoChecked   = this.form.querySelector('#gw-monogram-checkbox')?.checked;
      const monoVariantId = this.form.querySelector('#gw-monogram-addon-id')?.value?.trim();
      const initials      = (this.form.querySelector('#gw-monogram-initials')?.value || '').toUpperCase().trim();
      const parentVariant = this.form.querySelector('[name="id"]')?.value;
      const qty           = parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10);
      const sellingPlan   = this.form.querySelector('[name="selling_plan"]')?.value;

      const shouldAddMonogram = !!(monoChecked && monoVariantId);

      if (!shouldAddMonogram) {
        // --- Dawn default body (single add) ---
        const formData = new FormData(this.form);
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
      } else {
        // --- multi-item body: parent + monogram ---
        // split properties so __mono_* and Monogram go to child,
        // then DUPLICATE them back to parent as requested.
        const parentProps = {};
        const monoProps   = {};

        this.form.querySelectorAll('[name^="properties["]').forEach((el) => {
          const m = el.name.match(/^properties\[(.*)\]$/);
          if (!m) return;
          const key = m[1];
          const val = (el.type === 'checkbox') ? (el.checked ? 'Yes' : '') : (el.value ?? '');
          if (val === '') return;

          const isMonoKey = key.startsWith('__mono_') || key.toLowerCase() === 'monogram';

          if (isMonoKey) monoProps[key] = val;         // keep in child
          else parentProps[key] = val;                 // non-mono props stay with parent
        });

        // ensure initials also recorded as "Monogram" on child (and later parent)
        if (initials) monoProps['Monogram'] = initials;

        // link items for later paired removal
        const monoGroup = `mono:${parentVariant}:${Date.now()}`;
        parentProps['__mono_group'] = monoGroup;
        monoProps['__mono_group']   = monoGroup;
        monoProps['__parent_variant_id'] = String(parentVariant);

        // >>> NEW: duplicate monogram props onto the MAIN product too (except __parent_variant_id)
        Object.entries(monoProps).forEach(([k, v]) => {
          if (k === '__parent_variant_id') return;
          parentProps[k] = v;
        });
        // <<< END NEW

        const fd = new FormData();
        fd.append('sections', sectionIds.join(','));
        fd.append('sections_url', window.location.pathname);

        // items[0] parent
        fd.append('items[0][id]', String(parentVariant));
        fd.append('items[0][quantity]', isNaN(qty) ? '1' : String(qty));
        if (sellingPlan) fd.append('items[0][selling_plan]', String(sellingPlan));
        Object.entries(parentProps).forEach(([k, v]) => fd.append(`items[0][properties][${k}]`, v));

        // items[1] monogram
        fd.append('items[1][id]', String(monoVariantId));
        fd.append('items[1][quantity]', isNaN(qty) ? '1' : String(qty)); // or '1' if desired
        Object.entries(monoProps).forEach(([k, v]) => fd.append(`items[1][properties][${k}]`, v));

        config.body = fd;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((r) => r.json())
        .then(async (response) => {
          if (response?.status) {
            this.handleErrorMessage(response.description || 'Unable to add to cart.');
            return;
          }
          try {
            this.cartNotification?.renderContents?.(response);
          } catch (err) {
            console.warn('renderContents failed, fetching sections as fallback', err);
            await this.safeRenderSections(sectionIds);
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('Something went wrong. Please try again.');
        })
        .finally(() => {
          submitButton?.classList.remove('loading');
          submitButton?.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper?.querySelector('.product-form__error-message');

      this.errorMessageWrapper?.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}

